import gql from "graphql-tag";

export const GET_ALL_MLS = gql`
  query getAllMls {
    mls {
      id
      code
      name
      state
      is_child
      territory_code
      display_upsell_options
    }
  }
`;

export const GET_DISCOUNTS = gql`
  query {
    discounts {
      id
      code
      amount
      bundles {
        id
        name
        price
      }
      addOns: add_ons {
        id
        name
        price
      }
    }
  }
`;

export const GET_DISCOUNT_BY_CODE = gql`
  query GetDiscountByCode($code: String) {
    discounts(code: $code) {
      id
      code
      amount
      products {
        id
        name
        price
      }
      bundles {
        id
        name
        price
      }
    }
  }
`;

export const GET_ALL_PRODUCTS = gql`
  query getAllProducts {
    products(show_all: "true") {
      id
      key
      name
      price
      value
      site_license
      tagline
      discounts {
        id
        code
        amount
      }
    }
  }
`;

export const GET_PRODUCTS_FOR_MLS = gql`
  query products($mls_id: ID!) {
    products(mls_id: $mls_id) {
      id
      key
      name
      price
      value
      site_license
      tagline
      discounts {
        id
        code
        amount
      }
    }
  }
`;

export const GET_BUNDLES_FOR_MLS = gql`
  query bundles($mls_id: ID!) {
    bundles(mls_id: $mls_id) {
      id
      price
      name
      virtual
      tagline
      key
      discounts {
        id
        code
        amount
      }
      products {
        id
        name
        site_license
        price
        value
        tagline
      }
    }
  }
`;

export const GET_PLANS_FOR_MLS = gql`
  query getPlansForMls($id: ID, $code: String) {
    mls(id: $id, code: $code) {
      id
      code
      name
      state
      territory_code
      display_upsell_options
      has_homebeat
      products {
        id
        name
        price
        value
        key
        tagline
        site_license
        discounts {
          id
          code
          amount
        }
      }
      bundles {
        id
        name
        price
        tagline
        key
        discounts {
          id
          code
          amount
        }
        products {
          id
          name
          price
          value
          key
          tagline
          site_license
        }
      }
    }
  }
`;

export const LOAD_USER = gql`
  query loadUser {
    user {
      id
      name
      email
      jwt
      intercom_user_hash
      company_name
      phone_number
      website
      mls_credential {
        name
        code
      }
      products {
        id
        key
        name
        price
        value
        provisioned_account {
          id
          provisioned_at
        }
        onboarding_items {
          id
          key
          description
          action_link
          completed_at
          product_id
        }
      }
      provisioned_accounts {
        id
        remote_user_email
        product {
          id
          name
        }
      }
      mls {
        id
        code
        name
        state
        is_child
        territory_code
        bundles {
          virtual
          id
          name
          price
          tagline
          key
          discounts {
            id
            code
            amount
          }
          products {
            name
            id
            price
            value
            key
            tagline
            site_license
          }
        }
        products {
          id
          name
          price
          value
          key
          tagline
          site_license
          discounts {
            id
            code
            amount
          }
        }
      }
      payment {
        card_type
        expiration_date
        image_url
        last_4
        masked_number
      }
      subscription {
        can_cancel
        next_billing_period_amount
        next_bill_date
        price
        status
        balance
        products {
          key
          name
          price
          site_license
          discounts {
            code
            amount
          }
        }
        sku {
          name
          key
          type
        }
        discount {
          id
          code
        }
      }
    }
  }
`;

export const GET_USER_SUBSCRIPTION = gql`
  query getUserSubscription {
    user {
      subscription {
        id
        price
        balance
        status
        next_bill_date
        next_billing_period_amount
        sku {
          id
          key
          name
          description
        }
        products {
          id
          key
          name
          provisioned_account {
            id
            remote_user_email
            provisioned_at
          }
        }
      }
    }
  }
`;

export const GET_CHECKOUT_CONFIG = gql`
  query getCheckoutConfig {
    products(show_all: "true") {
      id
      key
      name
      tagline
      price
      value
    }
    mls {
      id
      code
      name
      state
      is_child
      territory_code
    }
    discounts {
      id
      code
      amount
      products {
        key
      }
      bundles {
        key
      }
    }
  }
`;

export const _GET_AUTHED_USER = gql`
  query getAuthedUser {
    user {
      id
      jwt
      name
      email
      intercom_user_hash
      company_name
      website
      phone_number
      mls {
        active
        code
        id
        is_child
        name
        state
        territory_code
        bundles {
          id
          key
          name
          price
          name
          tagline
          virtual
          products {
            key
            onboarding_items {
              key
            }
          }
        }
        products {
          id
          key
          name
          tagline
          price
          value
          site_license
          onboarding_items {
            key
          }
        }
      }
      mls_credential {
        code
        name
      }
      payment {
        card_type
        expiration_date
        last_4
        masked_number
      }
      add_on_subscriptions {
        id
        price
        next_bill_date
        next_billing_period_amount
        discount {
          id
          amount
        }
        sku {
          key
          name
          price
        }
      }
    }
    subscription {
      id
      price
      balance
      status
      next_bill_date
      next_billing_period_amount
      can_cancel
      transactions {
        id
        amount
        created_at
        discount_code
        type
        sku {
          key
          name
          type
        }
      }
      sku {
        key
        name
        description
      }
      products {
        id
        key
        name
        tagline
        price
        value
        site_license
        provisioned_account {
          id
          remote_user_email
          provisioned_at
        }
        onboarding_items {
          action_link
          completed_at
          description
          id
          key
          product_id
          sort
        }
      }
    }
  }
`;

export const GET_AUTHED_USER = gql`
  query getAuthedUser {
    user {
      id
      jwt
      name
      email
      intercom_user_hash
    }
  }
`;

export const GET_ADDON_QUERY = gql`
  query getAddOn($mlsCode: String, $addOnKey: String, $promoCode: String) {
    mls(code: $mlsCode) {
      id
    }
    addOns: add_ons(key: $addOnKey) {
      id
      key
      name
      price
      tagline
      billingCycle: billing_cycle
      discounts(code: $promoCode) {
        amount
        id
      }
    }
  }
`;

export const INIT_FASTRACK_QUERY = gql`
  query initFastrack($code: String) {
    allProducts: products(show_all: "true") {
      id
      key
      name
      price
      value
      tagline
      isSiteLicensed: site_license
    }
    mls(code: $code) {
      id
      code
      name
      state
      territoryCode: territory_code
      hasHomebeat: has_homebeat
      products {
        id
        name
        price
        value
        key
        tagline
        isSiteLicensed: site_license
        discounts {
          id
          code
          amount
        }
      }
      bundles {
        id
        name
        price
        tagline
        key
        billingCycle: billing_cycle
        discounts {
          id
          code
          amount
        }
        products {
          id
          name
          price
          value
          key
          tagline
          isSiteLicensed: site_license
        }
      }
    }
  }
`;
